import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { loadState } from "../services/browserStorage";
import loginReducer from "./reducer/LoginReducer";
import prenotationReducer from "./reducer/prenotationReducer";
import { useDispatch } from "react-redux";
import timeslotReducer from "./reducer/timeslotReducer";
import pharmaciesReducer from "./reducer/pharmaciesReducer";
import prenotationViewReducer from "./reducer/prenotationViewReducer";
import citizensReducer from "./reducer/citizensReducer";
import surveyReducer from "./reducer/surveyReducer";
import formReducer from "./reducer/formReducer";
import surveyHistoryReducer from "./reducer/surveyHistoryReducer";
import surveyReportReducer from "./reducer/surveyReportReducer";
import changePasswordReducer from "./reducer/changePasswordReducer";

const rootReducer = combineReducers({
  login: loginReducer,
  prenotation: prenotationReducer,
  prenotationView: prenotationViewReducer,
  timeslot: timeslotReducer,
  pharmacies: pharmaciesReducer,
  citizens: citizensReducer,
  surveys: surveyReducer,
  forms: formReducer,
  surveysHistory: surveyHistoryReducer,
  surveysReport: surveyReportReducer,
  changePassword: changePasswordReducer,
});

const Store = configureStore({
  reducer: rootReducer,
  preloadedState: loadState(),
});
export const useAppDispatch = () => useDispatch<typeof Store.dispatch>();

export default Store;
